const PanelItems = [
  {
    text: "下載列表",
    type: "downloadList",
  },
  {
    text: "產生網絡圖",
    type: "generateNetwork",
  },
];

export default PanelItems;
